import { LocalizedJoi } from "@/utils/localized-joi";
import type Joi from "joi";
import type { Dispatch, SetStateAction } from "react";

export const validateUserPassword = (
  object: unknown,
  setValidation: Dispatch<SetStateAction<Joi.ValidationErrorItem[]>>,
  userId?: string,
  field?: string,
): boolean => {
  if (userId) {
    return true;
  }

  const passwordValidation = LocalizedJoi.object({
    password: LocalizedJoi.string().min(6).max(20).required().label("Passord"),
    passwordConfirmation: LocalizedJoi.string()
      .valid(LocalizedJoi.ref("password"))
      .required()
      .label("Bekreft passord")
      .options({ messages: { "any.only": "Oppgitte passord må være like" } }),
  })
    .options({ allowUnknown: true })
    .validate(object);

  if (field) {
    if (passwordValidation.error?.details.some((d) => d.context?.label === field)) {
      setValidation(passwordValidation.error?.details.filter((d) => d.context?.label === field));
    } else {
      setValidation([]);
    }
  } else {
    setValidation(passwordValidation.error?.details ?? []);
  }

  return !passwordValidation.error;
};

export const validateOtherUserPassword = (
  object: unknown,
  setValidation: Dispatch<SetStateAction<Joi.ValidationErrorItem[]>>,
  isOtherPayer: boolean,
  field?: string,
): boolean => {
  if (!isOtherPayer) {
    return true;
  }
  const passwordValidation = LocalizedJoi.object({
    password: LocalizedJoi.string().min(6).max(20).required().label("Passord til medlem"),
    passwordConfirmation: LocalizedJoi.string()
      .valid(LocalizedJoi.ref("password"))
      .required()
      .label("Bekreft passord til medlem")
      .options({ messages: { "any.only": "Oppgitte passord må være like" } }),
  })
    .options({ allowUnknown: true })
    .validate(object);
  if (field) {
    if (passwordValidation.error?.details.some((d) => d.context?.label === field)) {
      setValidation(passwordValidation.error.details.filter((d) => d.context?.label === field) ?? []);
    } else {
      setValidation([]);
    }
  } else {
    setValidation(passwordValidation.error?.details ?? []);
  }

  return !passwordValidation.error;
};
